<template>
  <div class="addr">
    <p class="title">{{$t('contact.regionalOffice')}}</p>
    <div class="phone-warp">
      <template v-for="(item, index) in cityList">
        <div class="add-warp">
          <p class="title">{{item.cityName}}</p>
          <div
            class="content"
            style="word-break: break-all;white-space: pre-line;"
          >{{item.cityInfo}}</div>
        </div>
      </template>
    </div>
    <div class="map">
      <!-- 地图容器 -->
      <div
        id="citymap"
        style="overflow: hidden; position: relative; z-index: 0; background-color: rgb(243, 241, 236); color: rgb(0, 0, 0); text-align: left"
      ></div>
      <!-- 定位按钮 -->
      <button class="locate-btn" @click="locateUser" :title="$t('contact.locateMe')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      </button>
      <!-- 索引 -->
      <div class="city-info">
        <div class="city-name">
          <template v-for="(item, index) in cityList">
            <a
              href="javascript:void(0);"
              :class="item.isShow ? 'current' : ''"
              :key="index"
              @click="onClick(index)"
            >{{ item.cityName }}</a>
          </template>
        </div>
        <template v-for="(item, index) in cityList">
          <p v-show="item.isShow" style="padding: 30px" :key="index">
            <span>{{ item.cityInfo }}</span>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      map: null,
      currentMarker: null,
      currentLocationMarker: null,
      cityList: [
        {
          cityName: this.$t("contact.nameSZ"),
          cityInfo: `${this.$t("contact.infoSZ")}`,
          isShow: true,
          dataLat: "31.261832",
          dataLng: "120.74634"
        },
        {
          cityName: this.$t("contact.nameBJ"),
          // cityInfo: `地址：北京市朝阳区三间房南里 4 号院[8-6]1 幢 3 层 302 室;\n电话：010-86499090;传真：010-86499091;邮编：100029;\n国内商务发展部：010-53822552-8047;\n国际商务发展部：010-53822552-8062`,
          cityInfo: `${this.$t("contact.infoBJ")}`,
          isShow: false,
          dataLat: "39.912949",
          dataLng: "116.569199"
        },
        {
          cityName: this.$t("contact.nameSH"),
          cityInfo: `${this.$t("contact.infoSH")}`,
          // cityInfo: `地址：上海市浦东新区向城路58号东方国际科技大厦20楼A室;\n电话：021-68956021;\n邮编：200122`,
          isShow: false,
          dataLat: "31.223491",
          dataLng: "121.530281",
        },
        {
          cityName: this.$t("contact.nameGZ"),
          cityInfo: `${this.$t("contact.infoGZ")}`,
          // cityInfo: `地址：广东省广州市越秀区环市东路498号广发花园大厦柏丽广场11G;\n电话：020-37639091-810;\n邮编：510000`,
          isShow: false,
          dataLat: "23.125427",
          dataLng: "113.282595"
        },
        {
          cityName: this.$t("contact.nameCD"),
          cityInfo: `${this.$t("contact.infoCD")}`,
          // cityInfo: `地址：四川省成都市武侯区人民南路四段27号商鼎国际1-2-1802;\n电话：028-85009209;\n传真分机号：028-85009209-606;\n邮编：6100002`,
          isShow: false,
          dataLat: "30.653162",
          dataLng: "104.066727"
        },
        {
          cityName: this.$t("contact.nameXiAn"),
          cityInfo: `${this.$t("contact.infoXiAn")}`,
          // cityInfo: `地址：西安市经济技术开发区未央路以西,凤城7路以北，荣华国际商务中心项目2号楼4层409室;\n电话：029-87559397`,
          isShow: false,
          dataLat: "34.321531",
          dataLng: "108.972585"
          // 108.972585,34.321531
        },
        {
          cityName: this.$t("contact.nameSY"),
          cityInfo: `${this.$t("contact.infoSY")}`,
          // cityInfo: `地址：辽宁省沈阳市皇姑区黄河北大街52号中粮大厦902室;\n电话：024-892139281;\n邮编：110034`,
          isShow: false,
          dataLat: "41.826146",
          dataLng: "123.431016"
        },
        {
          cityName: this.$t("contact.nameNJ"),
          cityInfo: `${this.$t("contact.infoNJ")}`,
          // cityInfo: `地址：南京洲城科技园高淳汶溪路128号;\n邮编：110000`,
          isShow: false,
          dataLat: "31.355773",
          dataLng: "118.944803"
        },
        {
          cityName: this.$t("contact.nameSB"),
          cityInfo: `${this.$t("contact.infoSB")}`,
          // cityInfo: `地址：南京洲城科技园高淳汶溪路128号;\n邮编：110000`,
          isShow: false,
          dataLat: "32.047108",
          dataLng: "118.777958" 
        },
        {
          cityName: this.$t("contact.nameTJ"),
          cityInfo: `${this.$t("contact.infoTJ")}`,
          isShow: false,
          dataLat: "39.123198",
          dataLng: "117.174401"
        },
        // {
        //   cityName: this.$t("contact.nameTB"),
        //   cityInfo: `${this.$t("contact.infoTB")}`,
        //   isShow: false,
        //   dataLat: "25.060969",
        //   dataLng: "121.547957"
        // },
        // 杭州办公室
        {
          cityName: this.$t("contact.nameHZ"),
          cityInfo: `${this.$t("contact.infoHZ")}`,
          isShow: false,
          dataLat: "30.297137",
          dataLng: "120.215409"
        },
        // 武汉办公室
        // {
        //   cityName: this.$t("contact.nameWH"),
        //   cityInfo: `${this.$t("contact.infoWH")}`,
        //   isShow: false,
        //   dataLat: "30.58701158",
        //   dataLng: "114.28235870"
        // },
        // 郑州办公室
        {
          cityName: this.$t("contact.nameZZ"),
          cityInfo: `${this.$t("contact.infoZZ")}`,
          isShow: false,
          dataLat: "34.77669",
          dataLng: "113.708457"
        }
      ]
    };
  },
  mounted() {
    // 默认选择北京
    let timeout = 0;
    let interval = setInterval(() => {
      // 超时10秒加载失败
      if (timeout >= 20) {
        clearInterval(interval);
      }
      // 加载成功
      if (typeof L !== "undefined") {
        // console.log(L,"Leaflet")
        this.onClick(0);
        clearInterval(interval);
      }
      timeout += 1;
    }, 100);
  },
  methods: {
    locateUser() {
      if (!this.map) return;

      // 检查浏览器是否支持地理位置
      if (!navigator.geolocation) {
        alert(this.$t('contact.geolocationNotSupported'));
        return;
      }

      // 获取用户当前位置
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          // 移除旧的用户位置标记
          if (this.currentLocationMarker) {
            this.map.removeLayer(this.currentLocationMarker);
          }

          // 添加蓝色标记表示用户位置
          const blueIcon = L.divIcon({
            className: "custom-div-icon",
            html: `<div style="background-color: #2196F3; width: 24px; height: 24px; border-radius: 50%; border: 4px solid #fff; box-shadow: 0 2px 8px rgba(33, 150, 243, 0.5);"></div>`,
            iconSize: [24, 24],
            iconAnchor: [12, 12]
          });

          this.currentLocationMarker = L.marker([latitude, longitude], { icon: blueIcon }).addTo(this.map);

          // 定位到用户位置
          this.map.setView([latitude, longitude], 15);
        },
        (error) => {
          let errorMsg = '';
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMsg = this.$t('contact.permissionDenied');
              break;
            case error.POSITION_UNAVAILABLE:
              errorMsg = this.$t('contact.positionUnavailable');
              break;
            case error.TIMEOUT:
              errorMsg = this.$t('contact.geolocationTimeout');
              break;
            default:
              errorMsg = this.$t('contact.geolocationError');
          }
          alert(errorMsg);
        }
      );
    },
    onClick(index) {
      for (let item of this.cityList) {
        item.isShow = false;
      }
      this.cityList[index].isShow = true;
      //   获取当前位置经纬度（注意：经纬度顺序 Bing 是 lat,lng，Leaflet 是 lng,lat）
      let lat = this.cityList[index].dataLat;
      let lng = this.cityList[index].dataLng;

      // 获取当前语言
      let lang = sessionStorage.getItem("language") || "zh";
      let tileLang = lang === "zh" ? "zh_cn" : "en";

      // 创建地图（如果还未创建）
      if (!this.map) {
        this.map = L.map("citymap", {
          center: [lat, lng],
          zoom: 13,
          scrollWheelZoom: false,
          zoomControl: false
        });

        // 添加高德地图瓦片
        L.tileLayer(
          `http://webrd01.is.autonavi.com/appmaptile?lang=${tileLang}&size=1&scale=1&style=8&x={x}&y={y}&z={z}`,
          {
            attribution: '&copy; <a href="https://www.amap.com/">高德地图</a>'
          }
        ).addTo(this.map);
      } else {
        // 更新地图视图
        this.map.setView([lat, lng], 13);
      }

      // 移除旧标记
      if (this.currentMarker) {
        this.map.removeLayer(this.currentMarker);
      }

      // 添加红色标记
      const redIcon = L.divIcon({
        className: "custom-div-icon",
        html: `<div style="background-color: #ff4444; width: 24px; height: 24px; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); border: 3px solid #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.3);"></div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 24]
      });

      this.currentMarker = L.marker([lat, lng], { icon: redIcon }).addTo(this.map);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../style/constant";

.addr {
  padding: 100px 0 0;

  .title {
    text-align: center;
    color: @active-color;
    font-size: 16pt;
    margin-bottom: 60px;
    font-weight: bold;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .title {
      margin-bottom: 20px;
    }
  }

  /*手机样式*/

  .phone-warp {
    margin: 20px 0;
    display: none;

    .add-warp {
      padding: 10px 30px;

      .title {
        margin-bottom: 30px;
        text-align: left;
      }

      @media screen and (min-width: 320px) and (max-width: 480px) {
        .title {
          font-size: 18px;
          font-weight: bold;
          margin-top: 20px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .map {
    position: relative;
  }

  #citymap {
    width: 100%;
    height: 615px;
    max-width: 100%;
  }

  .locate-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 50px;
    height: 50px;
    background-color: #fff;
    border: none;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    svg {
      width: 24px;
      height: 24px;
      color: #2196F3;
    }

    &:hover {
      background-color: #2196F3;

      svg {
        color: #fff;
      }
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .city-info {
    width: @page-width;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -@map-margin-left;
    height: 200px;
    background: @from-icon-color;
    overflow: hidden;

    .city-name {
      padding: 30px 30px 0;

      .current {
        background: @active-color;
        color: #fff;
        font-weight: bold;
        border-radius: 15px;
      }
    }

    a {
      display: inline-block;
      padding: 7px;
      font-weight: 900;
      transition: all 0.3s;
      font-size: 13px;
      color: @active-color;
      text-decoration: none;
    }

    p {
      color: #fff;
      font-size: 12px;
      white-space: pre-wrap;
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .phone-warp {
    display: block !important;
  }

  .map {
    display: none;
  }
}
</style>
